import { api } from './client'

// ---------- tipuri — oglindesc DTO-urile din Cipral.Application/Approvals/ApprovalModels.cs ----------

export type ApprovalStatus = 'Pending' | 'Approved' | 'Rejected'

export interface ApprovalStep {
  stepOrder: number
  name: string
  status: ApprovalStatus
  decidedByUserName: string | null
  decidedAt: string | null
  comment: string | null
}

export interface ApprovalRequestListItem {
  id: string
  documentType: string
  documentSummary: string
  amount: number | null
  currency: string | null
  status: ApprovalStatus
  requestedByUserName: string
  requestedAt: string
  currentStepOrder: number
  totalSteps: number
}

export interface ApprovalRequestDetail {
  id: string
  documentType: string
  documentSummary: string
  amount: number | null
  currency: string | null
  status: ApprovalStatus
  requestedByUserName: string
  requestedAt: string
  steps: ApprovalStep[]
}

export const listMyApprovals = () => api.get<ApprovalRequestListItem[]>('/aprobari/mele').then((r) => r.data)
export const getApproval = (id: string) => api.get<ApprovalRequestDetail>(`/aprobari/${id}`).then((r) => r.data)
export const approveRequest = (id: string, comment?: string) => api.post(`/aprobari/${id}/aproba`, { comment: comment || null })
export const rejectRequest = (id: string, comment?: string) => api.post(`/aprobari/${id}/respinge`, { comment: comment || null })

// ---------- configurare fluxuri (FR-ADM-006) ----------

export interface FlowStep {
  id: string | null
  stepOrder: number
  name: string
  approverRoleId: string
  approverRoleName: string | null
}

export interface FlowDefinitionListItem {
  id: string
  documentType: string
  name: string
  minAmount: number | null
  currency: string | null
  isActive: boolean
  stepCount: number
}

export interface FlowDefinitionDetail {
  id: string
  documentType: string
  name: string
  minAmount: number | null
  currency: string | null
  isActive: boolean
  steps: FlowStep[]
}

export interface SaveFlowDefinitionPayload {
  documentType: string
  name: string
  minAmount: number | null
  currency: string | null
  steps: { id: string | null; stepOrder: number; name: string; approverRoleId: string }[]
}

export interface DocumentTypeRef { code: string; name: string }
export interface RoleRef { id: string; code: string; name: string }

export const listFlows = () => api.get<FlowDefinitionListItem[]>('/administrare/fluxuri-aprobare').then((r) => r.data)
export const getFlow = (id: string) => api.get<FlowDefinitionDetail>(`/administrare/fluxuri-aprobare/${id}`).then((r) => r.data)
export const listFlowDocumentTypes = () => api.get<DocumentTypeRef[]>('/administrare/fluxuri-aprobare/tipuri-document').then((r) => r.data)
export const listFlowRoles = () => api.get<RoleRef[]>('/administrare/fluxuri-aprobare/roluri').then((r) => r.data)

export const createFlow = (payload: SaveFlowDefinitionPayload) =>
  api.post<{ id: string }>('/administrare/fluxuri-aprobare', payload).then((r) => r.data)

export const updateFlow = (id: string, payload: SaveFlowDefinitionPayload) =>
  api.put(`/administrare/fluxuri-aprobare/${id}`, payload)

export const deactivateFlow = (id: string) => api.post(`/administrare/fluxuri-aprobare/${id}/deactivate`)
